
import { mixins, Options, Prop, Watch } from 'vue-property-decorator'
import { MinimalContentData } from '@rtl/api'

import ContentCardLeftImg from '../components/content/ContentCardLeftImg.vue'
import Loader from '../components/Loader.vue'
import WidgetMixin, { WidgetMeta, widgetMetaFields } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'Facebook content lista',
  fields: {
    ...widgetMetaFields,
    fbId: {
      label: 'Facebook Page ID',
      type: String,
      default: ''
    }
  }
}

@Options({
  name: 'FacebookPageWidget',
  components: {
    ContentCardLeftImg,
    Loader
  }
})
export default class FacebookPageWidget extends mixins(WidgetMixin) {
  @Prop({
    type: String,
    default: ''
  })
  readonly fbId!: string

  contentList: { items: Array<MinimalContentData> } | null = null

  @Watch('fbId')
  async fetch (): Promise<{ items: Array<MinimalContentData> }> {
    let items: Array<MinimalContentData> = []
    if (this.fbId) { // RTL Hiradó: 1390545061244776
      const token = 'EAAOGAliSSYoBOyWqEZC6UvToWDZCeOyZAoOfHj6vtJZCCCkJ80xUuPe9SZCH6FEbIZAbOKhLEXUjRXbKqYhHZBhOIKmeXk63hiQZC2Q4iUg6kvO49Xtq8pv2ZCXA6j1pDhs2hVJgiGolPpO0wZBIHcjo8qwmuhzShLPxRK1ySIZBBwcUdZCtQ66MJp9GxBv8cBq5WA1JZCJkk'
      const response = await fetch(`https://graph.facebook.com/v22.0/${this.fbId}/feed?access_token=${token}&fields=id,full_picture,story,message,created_time,properties,permalink_url`)
      const result: { data: Array<any> } = await response.json()
      items = result.data.filter(item => !item.story?.includes('live')).map(item => {
        return {
          source: item,
          id: item.id,
          title: '',
          lead: item.message,
          url: item.permalink_url,
          leadImageUrls: { leadImageUrl: item.full_picture },
          params: {
            withVideo: item.properties?.some((prop: any) => prop.name === 'Length') || false,
            duration: item.properties?.find((prop: any) => prop.name === 'Length')?.text
          },
          releaseDate: new Date (item.created_time)
        }
      })
    }

    const list = { items }
    this.contentList = list

    return list
  }

  async mounted () {
    return await this.fetch()
  }
}
